import script from "./AiWriteDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./AiWriteDescription.vue?vue&type=script&setup=true&lang=js"

import "./AiWriteDescription.vue?vue&type=style&index=0&id=05990430&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05990430"]])

export default __exports__